import { CheckoutPageVariables } from 'src/modules/checkout/CheckoutPageMapping.ts';
import { skipToken } from '@apollo/client';
import { isOCCOSelected } from 'src/modules/common/isOCCOSelected.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { getUnitByName } from 'src/modules/user-input/getUnitByName.ts';
import { targetUnits } from 'src/modules/user-input/targetUnits.ts';
import { Filter } from 'src/utils/composeFilter.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { UserInput } from 'src/modules/user-input/types.ts';

export const buildCheckoutVariables = ({
    filter, actuatorLabel, valveLabel, userSettings, userInput,
}: {
    filter: Filter;
    actuatorLabel: string;
    valveLabel: string;
    userSettings: UserSettings;
    userInput: UserInput;
}): { variables: CheckoutPageVariables } | typeof skipToken => {
    if (filter === null) {
        return skipToken;
    }
    return {
        variables: {
            actuatorLabel,
            valveLabel,
            locale: userSettings.currentLocale,
            isOCCO: isOCCOSelected(filter),
            kvs: userInput.kvs.length > 0 ? convert(
                userInput.kvs,
                getUnitByName(userInput.kvs_u, targetUnits.volumetricFlow),
                targetUnits.volumetricFlow,
            ) : '',
            kvs2: userInput.kvs_2.length > 0 ? convert(
                userInput.kvs_2,
                getUnitByName(userInput.kvs_2_u, targetUnits.volumetricFlow),
                targetUnits.volumetricFlow,
            ) : '',
            volumetricFlow: userInput.v100.length > 0 ? convert(
                userInput.v100,
                getUnitByName(userInput.v100_u, targetUnits.volumetricFlow),
                targetUnits.volumetricFlow,
            ) : '',
            volumetricFlow2: userInput.v100_2.length > 0 ? convert(
                userInput.v100_2,
                getUnitByName(userInput.v100_2_u, targetUnits.volumetricFlow),
                targetUnits.volumetricFlow,
            ) : '',
            dpmv: userInput.dpmv.length > 0 ? convert(
                userInput.dpmv,
                getUnitByName(userInput.dpmv_u, targetUnits.dpmv),
                targetUnits.dpmv,
            ) : '',
            dpmv2: userInput.dpmv2 && userInput.dpmv2.length > 0 ? convert(
                userInput.dpmv2,
                getUnitByName(userInput.dpmv_u, targetUnits.dpmv),
                targetUnits.dpmv,
            ) : '',
        },
    };
};
